module.exports = __webpack_public_path__ + "f7cda5ffd59eaf27653a2dd9df62a4c4.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_marketing.svg
// module id = ./images/space_marketing.svg
// module chunks = 5